import type { GroupedOption } from '@ksyos/design-system';
import { FormGroup, Select } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IService } from '@frontend/components/interfaces';
import { CarePathType } from '@common/enums/carePathType';
import { getSelectedLanguage } from '@frontend/translate';
import { getServicesGroupedByEpisodeCategoriesOptions, useAbortableFetch } from '@frontend/utils';

type ServiceFilterProps = {
    carePathType: CarePathType;
    onChange: (args: { episodeCategoryId: string | undefined; serviceId: string | undefined }) => void;
    selectedValue?: string;
};

export function ServiceFilter({ onChange, carePathType, selectedValue }: ServiceFilterProps) {
    const [isLoading, setIsLoading] = useState(true);
    const [serviceFilterValues, setServiceFilterValues] = useState<GroupedOption[]>([]);

    const translate = getSelectedLanguage();
    const abortableFetch = useAbortableFetch();

    useEffect(() => {
        loadServiceFilters();
    }, []);

    return (
        <FormGroup label={translate.service.service}>
            <Select
                isClearable
                isLoading={isLoading}
                loadingMessage={() => translate.common.loading}
                menuPlacement="auto"
                onChange={handleChange}
                options={serviceFilterValues}
                value={selectedValue ? serviceFilterValues.find((item) => item.value === selectedValue) : null}
            />
        </FormGroup>
    );

    function handleChange(selectedOption: GroupedOption | null) {
        const episodeCategoryId = selectedOption?.isGroupOption ? undefined : selectedOption?.value;
        const serviceId = selectedOption?.isGroupOption ? selectedOption?.value : undefined;

        onChange({ episodeCategoryId, serviceId });
    }

    async function loadServiceFilters() {
        const result = await abortableFetch.fetchJson('/api/services?limit=250', 'GET');
        const services = result.json.items.filter((service: IService) => {
            return carePathType === CarePathType.flex ? service.isFlex : !service.isFlex;
        });
        setServiceFilterValues(getServicesGroupedByEpisodeCategoriesOptions(services));
        setIsLoading(false);
    }
}
